module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/nagios.5218b403.png";